// noinspection NpmUsedModulesInstalled
import en from 'vuetify/es5/locale/en';
import langLocale from './en.json';

// merge with vuetify translation
const locale = Object.assign(langLocale, { $vuetify: en });

export default locale;
